const appBarHeight = 48;

export {appBarHeight}